import SplitType from 'split-type'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export const revealText = (el, config = {}) => {
  const duration = 0.5
  const delay = config.delay || 0
  const splittingTitle = new SplitType(el, { types: ['lines'] })

  splittingTitle.lines.forEach((line) => {
    const wrapper = document.createElement('div')
    wrapper.classList.add('line-wrapper')
    line.parentNode.insertBefore(wrapper, line)
    wrapper.appendChild(line)
  })

  gsap.set(el.querySelectorAll('.line-wrapper'), {
    overflow: 'hidden',
  })
  gsap.set(el.querySelectorAll('.line'), {
    transform: 'translate(-1px, 0%)', // Per lettere tagliate
    y: '120%',
  })

  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: el,
      start: 'top 70%',
      end: 'bottom bottom',
    },
    onComplete: () => {
      tl.kill()
      ScrollTrigger.refresh()
    },
  })
  tl.to(splittingTitle.lines, {
    y: '0%',
    ease: 'power4.out',
    stagger: 0.15,
    duration,
    delay,
  })
}
